import * as React from 'react';
import styles from './styles.module.scss';

type InputProps = {
  required?: boolean;
  children: string;
};

export const LabelStyled = ({ children, required = false }: InputProps) => {
  return (
    <span className={styles.root}>
      {children}
      {required && <span className={styles.red}> *</span>}
    </span>
  );
};
